import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'sbnb-thermostat-setup-success-presets',
  templateUrl: './thermostat-setup-success-presets.component.html',
  styleUrls: ['./thermostat-setup-success-presets.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThermostatSetupSuccessPresetsComponent {
  @HostBinding('class') class = 'contents';

  constructor(private readonly router: Router) {}

  continue() {
    this.router.navigate(['/devices/setup/thermostat-success/occupied']);
  }
}
